var createPatternBuilder = require('./createPatternBuilder');
module.exports = generateCreateBodyFunction;
module.exports.generateCreateBodyFunctionBody = generateCreateBodyFunctionBody;

// InlineTransform: getVectorCode
module.exports.getVectorCode = getVectorCode;
// InlineTransform: getBodyCode
module.exports.getBodyCode = getBodyCode;
// InlineTransformExport: module.exports = function() { return Body; }

function generateCreateBodyFunction(dimension, debugSetters) {
  var code = generateCreateBodyFunctionBody(dimension, debugSetters);
  var _Function = new Function(code)(),
    Body = _Function.Body;
  return Body;
}
function generateCreateBodyFunctionBody(dimension, debugSetters) {
  var code = "\n".concat(getVectorCode(dimension, debugSetters), "\n").concat(getBodyCode(dimension, debugSetters), "\nreturn {Body: Body, Vector: Vector};\n");
  return code;
}
function getBodyCode(dimension) {
  var pattern = createPatternBuilder(dimension);
  var variableList = pattern('{var}', {
    join: ', '
  });
  return "\nfunction Body(".concat(variableList, ") {\n  this.isPinned = false;\n  this.pos = new Vector(").concat(variableList, ");\n  this.force = new Vector();\n  this.velocity = new Vector();\n  this.mass = 1;\n\n  this.springCount = 0;\n  this.springLength = 0;\n}\n\nBody.prototype.reset = function() {\n  this.force.reset();\n  this.springCount = 0;\n  this.springLength = 0;\n}\n\nBody.prototype.setPosition = function (").concat(variableList, ") {\n  ").concat(pattern('this.pos.{var} = {var} || 0;', {
    indent: 2
  }), "\n};");
}
function getVectorCode(dimension, debugSetters) {
  var pattern = createPatternBuilder(dimension);
  var setters = '';
  if (debugSetters) {
    setters = "".concat(pattern("\n\
   var v{var};\n\
Object.defineProperty(this, '{var}', {\n\
  set: function(v) { \n\
    if (!Number.isFinite(v)) throw new Error('Cannot set non-numbers to {var}');\n\
    v{var} = v; \n\
  },\n\
  get: function() { return v{var}; }\n\
});"));
  }
  var variableList = pattern('{var}', {
    join: ', '
  });
  return "function Vector(".concat(variableList, ") {\n  ").concat(setters, "\n    if (typeof arguments[0] === 'object') {\n      // could be another vector\n      let v = arguments[0];\n      ").concat(pattern('if (!Number.isFinite(v.{var})) throw new Error("Expected value is not a finite number at Vector constructor ({var})");', {
    indent: 4
  }), "\n      ").concat(pattern('this.{var} = v.{var};', {
    indent: 4
  }), "\n    } else {\n      ").concat(pattern('this.{var} = typeof {var} === "number" ? {var} : 0;', {
    indent: 4
  }), "\n    }\n  }\n  \n  Vector.prototype.reset = function () {\n    ").concat(pattern('this.{var} = ', {
    join: ''
  }), "0;\n  };");
}